// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"b40c8816","717":"d7cbcbe7"}[chunkId] + ".css";
};